import { useEffect, useState } from "react";
import Product from "./Product";
import Scroll from "./Scroll";

function Cod() {
  const [products, setProducts] = useState([]);

  const getProducts = async () => {
    const response = await fetch("https://fakestoreapi.com/products");
    const data = await response.json();
    setProducts(data);
  };

  useEffect(() => {
    getProducts();
  }, []);
  return (
    <div className="w-full border-t">
      <div className="flex items-end space-x-3 py-5">
        <h1 className="h1-bold">Bayar di tempat {`< 49rb`}</h1>
        <p className="font-semibold text-tokped_green text-lg cursor-pointer hover:text-green-600">
          Lihat Semua
        </p>
      </div>

      <Scroll>
        {products?.map((product) => (
          <Product
            key={product.id}
            img={product.image}
            title={product.title}
            price={product.price}
            discount
            rating={product.rating}
            className="flex-shrink-0 w-56"
          />
        ))}
      </Scroll>
    </div>
  );
}

export default Cod;
